import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ReportFilterModel extends ModeModelBase {
  override _name = 'reportFilter';
  override idAttribute = 'token';
  override belongsTo = 'report';
  override parentIdAttribute = 'token';

  override attributes = [
    { name: 'name' },
    { name: 'row_order' },
    { name: 'formula' },
    { name: 'data_type' },
    { name: 'formula_type' },
    { name: 'variable_type' },
    { name: 'filter_type' },
    { name: 'control_type' },
    { name: 'hide_select_all', default: false },
    { name: 'show_relevant_values_only', default: false },
    { name: 'options' },
  ];
}

@Injectable({ providedIn: 'root' })
export class ReportFilterModelAccessor extends ModelAccessorBase<ReportFilterModel> {
  override name = 'reportFilter';
  override idAttribute = 'token';
  override parentModel = 'report';
  override parentIdAttribute = 'token';
  override createAttributes = ['report'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.reportFilter');
  }

  createModel(resource, opts?) {
    const model = new ReportFilterModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
